<template>
  <div class="main-box">

    <div class="title-box">
      <h1>{{ title }}</h1>
    </div>

      <div class="promot-box">

        <div class="cont-left">
          <div :class="'float-tip lv-' + (userLevel + 1)" v-if="(userLevel + 1) <= 3">
            <p v-for="val in dataLevelItem">{{val}}</p>
            <i class="el-icon-caret-right"></i>
          </div>

          <div :class="[ 'lvl-' + (item.level + 1),
                      { 'active': item.level === userLevel }]"
               v-for="item in dataLevelList">
            <span class="lvl-tip">“{{item.name}}”推广员</span>
            <span>{{ item.percentageDesc }}</span>
            <div class="my-lvl" v-if="item.level === userLevel">当前</div>
          </div>
        </div>

        <div class="cont-right" v-if="showUpDiv">
          <div class="title">分享方式：</div>
          <div class="r-btn">
            <div @click="openShare('url')">
              <i class="el-icon-link"></i>
              <span>链接分享</span>
            </div>
            <div @click="openShare('img')">
              <i class="el-icon-postcard"></i>
              <span>海报分享</span>
            </div>
          </div>
          <div class="title" v-if="(2- userLevel) >= 0 && dataLevelList && dataLevelList[2- userLevel].upgradeMoney != 0">付费升级：</div>
          <div class="r-btn2 btn-pc-show" v-if="(2- userLevel) >= 0 && dataLevelList && dataLevelList[2- userLevel].upgradeMoney != 0" @click="showUp">
            <div class="svg-icon">
              <svg t="1724490665045" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5148" width="20" height="20" fill="#409EFF">
                <path d="M810.438503 379.664884l-71.187166-12.777183C737.426025 180.705882 542.117647 14.602496 532.991087 7.301248c-12.777184-10.951872-32.855615-10.951872-47.45811 0-9.12656 7.301248-204.434938 175.229947-206.26025 359.586453l-67.536542 10.951871c-18.253119 3.650624-31.030303 18.253119-31.030303 36.506239v189.832442c0 10.951872 5.475936 21.903743 12.777184 27.379679 7.301248 5.475936 18.253119 9.12656 29.204991 7.301248l135.073084-23.729055c40.156863 47.458111 93.090909 74.83779 149.675579 74.837789 56.58467 0 109.518717-25.554367 149.675579-74.837789l136.898396 23.729055c10.951872 1.825312 21.903743-1.825312 29.204991-7.301248 9.12656-7.301248 12.777184-16.427807 12.777184-27.379679V414.345811c3.650624-16.427807-9.12656-31.030303-25.554367-34.680927zM766.631016 564.02139l-114.994652-20.078431c-14.602496-1.825312-27.379679 3.650624-36.506239 14.602496-27.379679 40.156863-65.71123 62.060606-105.868093 62.060606-40.156863 0-76.663102-21.903743-105.868093-62.060606-7.301248-9.12656-18.253119-14.602496-29.204991-14.602496h-5.475936L255.543672 564.02139v-116.819964l69.361854-12.777184c18.253119-3.650624 31.030303-20.078431 31.030303-38.33155v-27.37968c0-118.645276 107.693405-237.290553 156.976827-284.748663 49.283422 47.458111 156.976827 166.103387 156.976827 284.748663v27.37968c-1.825312 18.253119 12.777184 34.680927 31.030303 38.33155l71.187166 12.777184v116.819964H766.631016zM620.606061 766.631016H401.568627c-20.078431 0-36.506239 16.427807-36.506238 36.506239v109.518716c0 14.602496 9.12656 29.204991 23.729055 34.680927 14.602496 5.475936 31.030303 1.825312 40.156863-9.126559l16.427807-18.25312 32.855615 80.313726c5.475936 14.602496 18.253119 23.729055 34.680927 23.729055 16.427807 0 27.379679-9.12656 34.680927-23.729055l32.855615-80.313726 16.427807 18.25312c10.951872 10.951872 25.554367 14.602496 40.156863 9.126559 14.602496-5.475936 23.729055-18.253119 23.729055-34.680927v-109.518716c-3.650624-20.078431-20.078431-36.506239-40.156862-36.506239z m-109.518717 122.2959L491.008913 839.643494H529.340463l-18.253119 49.283422z" p-id="5149"></path>
              </svg>
            </div>
            <span>{{ dataLevelList ? dataLevelList[2- userLevel].payUpgradeDesc : '' }}</span>
          </div>
          <div class="r-btn2 btn-h5-show" v-if="(2- userLevel) >= 0 && dataLevelList && dataLevelList[2- userLevel].upgradeMoney != 0" @click="downloadBtn2">
            <div class="svg-icon">
              <svg t="1724490665045" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5148" width="20" height="20" fill="#409EFF">
                <path d="M810.438503 379.664884l-71.187166-12.777183C737.426025 180.705882 542.117647 14.602496 532.991087 7.301248c-12.777184-10.951872-32.855615-10.951872-47.45811 0-9.12656 7.301248-204.434938 175.229947-206.26025 359.586453l-67.536542 10.951871c-18.253119 3.650624-31.030303 18.253119-31.030303 36.506239v189.832442c0 10.951872 5.475936 21.903743 12.777184 27.379679 7.301248 5.475936 18.253119 9.12656 29.204991 7.301248l135.073084-23.729055c40.156863 47.458111 93.090909 74.83779 149.675579 74.837789 56.58467 0 109.518717-25.554367 149.675579-74.837789l136.898396 23.729055c10.951872 1.825312 21.903743-1.825312 29.204991-7.301248 9.12656-7.301248 12.777184-16.427807 12.777184-27.379679V414.345811c3.650624-16.427807-9.12656-31.030303-25.554367-34.680927zM766.631016 564.02139l-114.994652-20.078431c-14.602496-1.825312-27.379679 3.650624-36.506239 14.602496-27.379679 40.156863-65.71123 62.060606-105.868093 62.060606-40.156863 0-76.663102-21.903743-105.868093-62.060606-7.301248-9.12656-18.253119-14.602496-29.204991-14.602496h-5.475936L255.543672 564.02139v-116.819964l69.361854-12.777184c18.253119-3.650624 31.030303-20.078431 31.030303-38.33155v-27.37968c0-118.645276 107.693405-237.290553 156.976827-284.748663 49.283422 47.458111 156.976827 166.103387 156.976827 284.748663v27.37968c-1.825312 18.253119 12.777184 34.680927 31.030303 38.33155l71.187166 12.777184v116.819964H766.631016zM620.606061 766.631016H401.568627c-20.078431 0-36.506239 16.427807-36.506238 36.506239v109.518716c0 14.602496 9.12656 29.204991 23.729055 34.680927 14.602496 5.475936 31.030303 1.825312 40.156863-9.126559l16.427807-18.25312 32.855615 80.313726c5.475936 14.602496 18.253119 23.729055 34.680927 23.729055 16.427807 0 27.379679-9.12656 34.680927-23.729055l32.855615-80.313726 16.427807 18.25312c10.951872 10.951872 25.554367 14.602496 40.156863 9.126559 14.602496-5.475936 23.729055-18.253119 23.729055-34.680927v-109.518716c-3.650624-20.078431-20.078431-36.506239-40.156862-36.506239z m-109.518717 122.2959L491.008913 839.643494H529.340463l-18.253119 49.283422z" p-id="5149"></path>
              </svg>
            </div>
            <span>{{ dataLevelList ? dataLevelList[2- userLevel].payUpgradeDesc : '' }}</span>
          </div>
          <ul>
            <li class="tit-li">1.代理分级规则：</li>
            <li v-for="item in rulesList.levelRules">{{ item }}</li>
            <li class="tit-li">2.代理分成规则：</li>
            <li v-for="item in rulesList.shareRules">{{ item }}</li>
            <li class="tit-li">3.返现到款日期：被分享者下单7天后返现到账</li>
          </ul>
        </div>

        <div class="cont-right" v-else>
          <div class="title-btn" @click="closeUp">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
          <div class="content-order">
            <div class="content-list active" v-if="userUpLevelOrder.showUpgradeReward">
              第 {{userUpLevelOrder.upgradeRewardCount}} 单 {{ Number(userUpLevelOrder.upgradeRewardPercentage) * 100 }}% 分成
            </div>
            <div class="content-list">后续订单 {{ Number(userUpLevelOrder.percentage) * 100 }}% 分成</div>
          </div>
          <div class="pay-box">
            <div class="pay-cont">
              <div class="pay-img">
                <div v-if="userUpLevelOrder.qrCode">
                  <generateQRCode :url="userUpLevelOrder.qrCode"></generateQRCode>
                </div>
              </div>
              <div class="pay-text">
                <p><span>{{userUpLevelOrder.price}}元</span><i>{{userUpLevelOrder.showPrice}}元</i></p>
                <p>{{ userUpLevelOrder.payOrderDesc }}</p>
                <div class="pay-tip">
                  <img alt="" src="@/assets/images/icon/wx-pay2.png">
                  <img alt="" src="@/assets/images/icon/zfb-pay2.png">
                  <p>使用微信、支付宝扫码支付</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <el-dialog
        title=""
        :visible.sync="centerDialogVisible"
        class="showVisible"
        center>
        <div class="share-url" v-if="content === 'url'">
          <div class="share-title" v-if="shareLinkData && shareLinkData.showUpgradeInfo">
            <h3>分享{{ shareLinkData.upgradeCount }}位好友下单，成为{{ shareLinkData.nextLevelName }}推广员</h3>
            <p>成为推广员后获得{{ Number(shareLinkData.upgradePercentage) * 100 }}%提成哦！！</p>
          </div>
          <div class="url-item">
            <p>{{shareLinkData.link}}</p>
            <div class="copy" :data-clipboard-text="copyText" @click="copyUrl(shareLinkData.link)">复制链接</div>
          </div>
          <div class="url-ul">
            <div>如何才算邀请成功？</div>
            <p><span>1</span>复制分享链接</p>
            <p><span>2</span>将分享链接通过社交工具发送给好友</p>
            <p><span>3</span>好友通过分享链接进入网站下单</p>
          </div>
        </div>

        <div class="share-url" v-if="content === 'img'">
          <div class="share-title" v-if="shareLinkData && shareLinkData.showUpgradeInfo">
            <h3>分享{{ shareLinkData.upgradeCount }}位好友下单，成为{{ shareLinkData.nextLevelName }}推广员</h3>
            <p>成为推广员后获得{{ Number(shareLinkData.upgradePercentage) * 100 }}%提成哦！！</p>
          </div>
          <div class="img-box">
            <div class="img-item" id="psotHtmlImg">
              <div class="img-user">
                <i class="el-icon-user-solid"></i>
                <div class="img-user-name">
                  <span v-for="val in userInfo.nickname.split(':')">{{val}}</span>
                </div>
              </div>
              <div v-if="shareLinkData && shareLinkData.link">
                <generateQRCode class="ewm-img" :url="shareLinkData.link"></generateQRCode>
              </div>
              <img class="poster-bg" src="@/assets/images/promotion-poster.jpg" alt="">
            </div>
            <div class="url-ul">
              <div>如何才算邀请成功？</div>
              <p><span>1</span>复制分享链接</p>
              <p><span>2</span>将分享链接通过社交工具发送给好友</p>
              <p><span>3</span>好友通过分享链接进入网站下单</p>
            </div>
          </div>
          <div class="url-btn">
            <div id="copyImg" :data-clipboard-text="copyImg" @click="copyImgUrl">
              <i class="el-icon-copy-document"></i>
              <span>复制海报链接</span>
            </div>
            <div @click="downloadPostHtmlImg">
              <i class="el-icon-download"></i>
              <span>下载海报</span>
            </div>
          </div>
        </div>
      </el-dialog>

      <DownloadH5 ref="Download" @downloadOff="downloadOff"/>
      <Login ref="showLogin"></Login>
  </div>
</template>
<script>
import PromotionApi from '@/api/promotion'
import CommonApi from "@/api/common"
import generateQRCode from "@/components/generateQRCode/generateQRCode.vue"
import Clipboard from "clipboard"
import html2canvas from "html2canvas"
import DownloadH5 from "@/components/downloadH5/downloadH5.vue"
import Login from "@/components/login/login.vue"
import {EventBus} from "@/utils/eventBus"

export default {
  name: 'Promot',
  components:{
    Login,
    DownloadH5,
    generateQRCode
  },
  data() {
    return {
      userInfo: {
        isLogin: false, // 用户登录状态
        username: '',
        nickname: '',
        token: ''
      },
      userSetInfo: '',
      userLevel: 0,
      title: '推广员',
      centerDialogVisible: false,
      loginDialogVisible: false,
      content: '',
      rulesList: '',
      loginDetail: '',
      timer2: null,
      dataLevelList: '',
      dataLevelItem: [],
      shareLinkData: '',
      showUpDiv: true,
      userUpLevelOrder: '',
      copyText: '',
      copyImg: '',
      psotHtmlImgUrl: '',
      shake: false,
      showH5: false
    }
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if(userInfo){
      this.userInfo = userInfo
    }
    let userSetInfo = JSON.parse(localStorage.getItem('userSetInfo'))
    if(userSetInfo){
      this.userSetInfo = userSetInfo
    }
    this.getLevelRule()
    this.getUserInfo()
  },
  watch: {
    userInfo: {
      handler(newVal, oldVal) {
        // 当userInfo对象中的任何属性变化时都会触发
        if (newVal.isLogin !== oldVal.isLogin) {
          // 特定于isLogin变化的逻辑
          this.userInfo.isLogin = newVal.isLogin
        }
      },
      deep: true // 开启深度监听
    },
    userSetInfo: {
      handler(newVal, oldVal) {
        // 当userInfo对象中的任何属性变化时都会触发
        this.userSetInfo = newVal
      },
      deep: true // 开启深度监听
    }
  },
  mounted() {
    EventBus.$on('userLogin', (msg) => {
      if(msg === 'userLoginTrue'){
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.userSetInfo = JSON.parse(localStorage.getItem('userSetInfo'))
        this.getUserInfo()
      }
    })
    EventBus.$on('userSetInfo', (msg) => {
      if(msg === 'userInfoTrue'){
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.userSetInfo = JSON.parse(localStorage.getItem('userSetInfo'))
      }
    })
    EventBus.$on("userOutLogin", (msg) => {
      // 退出登录发送来的消息
      if(msg === 'userOutLoginTrue'){
        this.userInfo = this.$options.data().userInfo
        this.userSetInfo = ''
      }
    })
  },
  beforeDestroy() {
    //清除定时器查询
    clearInterval(this.timer2);
  },
  methods: {
    // getUserInfo2(msg){
    //   // console.log(msg)
    //   if (msg && msg.user === false){
    //     this.userInfo = this.$options.data().userInfo
    //   }else {
    //     this.userInfo = msg.info
    //     this.getLevelList(this.userInfo.token)
    //   }
    // },
    // 获取登录信息
    getUserInfo(){
      // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      // if(userInfo){
      //   this.userInfo = userInfo
      //   if(this.userInfo.isLogin){
      //     this.getLevelList(this.userInfo.token)
      //   }
      // }else {
      //   this.getLevelList()
      // }
      if(this.userInfo.isLogin){
        this.getLevelList(this.userInfo.token)
      } else {
        this.getLevelList()
      }
    },
    // 获取级别规则信息
    getLevelRule(){
      let _this = this;
      PromotionApi.getLevelRule().then(res => {
        // levelRules 、 shareRules
        _this.rulesList = res.data
      }).catch(() => {
      })
    },
    // 获取级别信息
    getLevelList(token){
      let _this = this;
      PromotionApi.getLevelList(token).then(res => {
        // console.log(res.data)
        _this.dataLevelList = res.data
        _this.dataLevelList.forEach(item => {
          if(item.currentLevel === true){
            _this.userLevel = item.level
          }
        })
        _this.dataLevelItem = _this.dataLevelList[2 - _this.userLevel].upgradeDesc.split(',')
      }).catch(() => {
      })
    },
    goNav(){
      localStorage.setItem('currentIndex',1)
      this.$router.push('/index')
    },
    openShare(type){
      if(!this.userInfo.isLogin){
        return this.$refs.showLogin.openLogin()
      }
      // console.log(type === 'url')
      this.content = type
      this.shareLink(this.userInfo.token)
      this.centerDialogVisible = true
      if(!this.psotHtmlImgUrl && type === 'img'){
        setTimeout(()=>{
          this.createPostHtmlImg()
        },500)
      }
    },
    // 打开用户升级面板
    showUp(){
      if(!this.userInfo.isLogin){
        return this.$refs.showLogin.openLogin()
      }
      this.createOrder(this.userInfo.token)
    },
    // 移动端打开用户升级面板
    downloadBtn2(){
      if(!this.userInfo.isLogin){
        return this.$refs.showLogin.openLogin()
      }
      this.showH5 = true
      this.createOrder(this.userInfo.token)
    },
    downloadOff(info){
      this.showH5 = info.showState
      if(!info.payState){
        clearInterval(this.timer2)
      }
    },
    // 关闭用户升级面板
    closeUp(){
      //清除订单支付定时器
      clearInterval(this.timer2)
      this.showUpDiv = true
    },
    // 链接分享
    shareLink(token,channelCode){
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = this.$md5(setOf)
      PromotionApi.shareLink(token,channelCode,key,time,infoMd5).then(res => {
        // console.log(res.data)
        this.shareLinkData = res.data
      }).catch(() => {
        // 登录失效 清除历史记录，打开登录面板
        // this.userInfo = this.$options.data().userInfo
        this.outLogin()
        this.$refs.showLogin.openLogin()
      })
    },
    outLogin(){
      // 模拟退出
      this.userInfo = this.$options.data().userInfo
      localStorage.removeItem('userInfo')
      localStorage.removeItem('userSetInfo')
      // 传递 退出登录 的消息
      EventBus.$emit("userOutLogin", 'userOutLoginTrue')
    },
    // 复制分享链接
    copyUrl(url){
      this.copyText = url
      let clipboard = new Clipboard( '.copy')
      clipboard.on('success', (e) => {
        // 释放内存
        clipboard.destroy()
        this.$message.success('复制成功')
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        // console.log('该浏览器不支持自动复制', e)
        // 释放内存
        clipboard.destroy()
      })
    },
    // 创建充值升级订单
    createOrder(token,channelCode){
      let _this = this
      PromotionApi.createOrder(token,channelCode).then(res => {
        // console.log(res.data)
        _this.userUpLevelOrder = res.data
        // _this.showUpDiv = false
        // _this.getTimeFun(_this.userUpLevelOrder.id)
        // 移动端 H5 适配
        if(_this.showH5){
          let params = {
            show: true,
            title: '推广升级',
            info: _this.userUpLevelOrder
          }
          this.$refs.Download.showDrawer(params)
        }else {
          _this.showUpDiv = false
        }
        _this.getTimeFun(_this.userUpLevelOrder.id)
      }).catch(() => {
      })
    },
    //定时器查询订单状态
    getTimeFun(id){
      this.timer2 = setInterval(() => {
        this.getQueryPayState(id)
      }, 3000);
    },
    // 查询订单支付状态
    getQueryPayState(orderId){
      let _this = this
      CommonApi.queryPayState(orderId).then(res => {
        // _this.orderCont = res.data
        if(res.data){
          // 清除订单支付定时器
          clearInterval(_this.timer2)
          // 支付完成后调用
          _this.orderCompleted()
        }
      }).catch(() => {
      })
    },
    // 支付完成后调用
    orderCompleted(){
      this.getUserInfo()
      this.closeUp()
    },
    // 生成海报
    createPostHtmlImg(){
      let _this = this
      setTimeout(()=>{
        let postDOM = document.getElementById('psotHtmlImg')
        html2canvas(postDOM,{
          width: postDOM.offsetWidth,
          height: postDOM.offsetHeight,
          // 按比例增加分辨率
          scale: 3, //设备像素比  window.devicePixelRatio = 1
          useCORS: true, //图片跨域相关
          allowTaint: true, //允许跨域
          logging: false,
          letterRendering: true,
        }).then((canvas)=>{
          _this.psotHtmlImgUrl = canvas.toDataURL('image/png');
          setTimeout(()=>{
            _this.uploadImage()
          },500)
        })
      },200)
    },
    // 生成海报 上传获取 URL 地址
    updateImgtoFile(){
      let dataurl = this.psotHtmlImgUrl
      let filename = 'file'
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const suffix = mime.split('/')[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    uploadImage() {
      let _this = this
      let file = this.updateImgtoFile()
      const formData = new FormData();
      formData.append('file', file);
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = this.$md5(setOf)
      PromotionApi.shareImage(formData,_this.userInfo.token,key,time,infoMd5).then(res => {
        _this.copyImg = res.data
      }).catch(() => {
      })
    },
    // 复制海报链接
    copyImgUrl(){
      if(this.shake === true){
        return
      }
      this.shake = true
      let clipboard = new Clipboard( '#copyImg')
      clipboard.on('success', (e) => {
        // console.log('复制', e)
        this.$message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // console.log('该浏览器不支持自动复制', e)
        // 释放内存
        clipboard.destroy()
      })
      setTimeout(()=>{
        this.shake = false
      },1000)
    },
    // 下载海报
    downloadPostHtmlImg(){
      let _this = this
      if(_this.shake === true){
        return
      }
      _this.shake = true
      let a = document.createElement('a');
      a.download = 'AI咦呀写作'
      a.href = _this.psotHtmlImgUrl
      a.dispatchEvent(new MouseEvent('click'))
      setTimeout(()=>{
        _this.shake = false
      },1000)
    }
  }
}
</script>
<style scoped lang="less">
.main-box {
  width: 90%;
  margin: 0 auto;
  padding-top: 20px;

  .title-box {
    height: 60px;

    h1 {
      position: relative;
      z-index: 1;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
    }

    h1::before {
      content: '';
      z-index: -1;
      position: absolute;
      bottom: -2px;
      left: 50%;
      width: 104px;
      height: 12px;
      margin-left: -52px;
      background-color: rgba(42, 171, 255, 0.3);
    }
  }

  .promot-box {
    width: 100%;
    border-radius: 15px;
    border: 1px solid #ffffff;
    box-shadow: 0 0 15px rgba(81, 59, 248, 0.1);
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    .cont-left {
      position: relative;
      width: 40%;
      min-height: 508px;
      max-height: 508px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      > div {
        position: relative;
        margin-top: 20px;
        height: 100px;
        border-radius: 15px;
        border: 1px solid rgba(95, 133, 255, 0.1);
        background-color: rgba(95, 133, 255, 0.1);
        box-shadow: 0 3px 6px 1px rgba(48, 148, 230, 0.1);
        //box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        span {
          font-size: 16px;
          color: #3c3c3c;
        }

        span.lvl-tip {
          font-size: 14px;
          color: #409EFF;
          margin-bottom: 6px;
        }

        .my-lvl {
          position: absolute;
          top: -1px;
          right: -1px;
          padding: 3px 10px;
          border: 1px solid #ffffff;
          border-radius: 0 15px 0 15px;
          font-size: 12px;
          color: #ffffff;
        }
      }

      .lvl-1 {
        width: 66%;
      }

      .lvl-2 {
        width: 60%;
      }

      .lvl-3 {
        width: 54%;
      }

      .lvl-4 {
        width: 48%;
      }

      .active {
        border: 1px solid rgba(95, 133, 255, 1);
        background-color: rgba(95, 133, 255, 1);

        span {
          color: #ffffff;
        }

        span.lvl-tip {
          color: #ffffff;
        }
      }

      .float-tip {
        position: absolute;
        z-index: 10;
        left: -60px;
        width: 120px;
        height: 54px;
        margin-bottom: 20px;
        border-radius: 5px;
        border: 1px solid #409EFF;
        background-color: rgba(255, 255, 255, 0.9);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        i {
          position: absolute;
          top: 20px;
          right: -9px;
          color: #409EFF;
        }

        p {
          font-size: 12px;
          color: #409EFF;

          span {
            margin: 0 5px;
            font-size: 18px;
          }
        }
      }

      .lv-1 {
        bottom: 26px;
      }

      .lv-2 {
        bottom: 148px;
      }

      .lv-3 {
        bottom: 268px;
      }
    }

    .cont-right {
      width: 60%;
      min-height: 508px;
      padding: 20px 20px 20px 40px;
      border-radius: 0 15px 15px 0;
      background-color: rgba(149, 179, 255, 0.1);

      .title {
        padding-bottom: 16px;
        font-size: 14px;
      }

      .r-btn {
        margin-bottom: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        > div {
          width: 126px;
          height: 40px;
          margin-right: 20px;
          border-radius: 5px;
          background-image: linear-gradient(90deg, #409EFF, #6e83f7);
          box-shadow: 0 2px 5px rgba(81, 59, 248, 0.3);
          cursor: pointer;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          i {
            font-size: 18px;
            color: #ffffff;
          }

          span {
            margin-left: 5px;
            font-size: 14px;
            color: #ffffff;
          }
        }
      }

      .r-btn2 {
        width: 272px;
        height: 40px;
        margin-bottom: 20px;
        border-radius: 5px;
        border: 1px solid #409EFF;
        background-color: rgba(255, 255, 255, 0.7);
        box-shadow: 0 2px 5px rgba(81, 59, 248, 0.3);
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .svg-icon {
          overflow: hidden;
          width: 20px;
          height: 20px;
        }

        span {
          margin-left: 5px;
          font-size: 14px;
          color: #409EFF;
        }
      }

      .btn-pc-show {
        display: flex;
      }

      .btn-h5-show {
        display: none;
      }

      ul {
        li {
          line-height: 24px;
          font-size: 12px;
          color: #808080;
        }

        li.tit-li {
          padding: 10px 0;
          font-size: 14px;
          color: #3c3c3c;
        }
      }

      .title-btn {
        box-sizing: border-box;
        width: 100%;
        text-align: left;
        color: #3c3c3c;
        font-size: 14px;
        cursor: pointer;
      }

      .content-order {
        width: 60%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        .content-list {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 320px;
          height: 80px;
          background: #ffffff;
          box-shadow: 0 4px 12px 1px rgba(81, 48, 230, 0.1);
          border-radius: 8px;
          opacity: 1;
          border: 1px solid #dcdcf5;
          margin-bottom: 42px;
        }

        .active::after {
          content: "";
          position: absolute;
          width: 0;
          height: 30px;
          opacity: .3;
          border: 1px dashed #707070;
          bottom: -38px;
        }

        .content-list:last-child {
          margin-bottom: 0;
        }
      }

      .pay-box {
        width: 90%;
        margin: 0 auto;
        padding-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        .pay-cont {
          width: 100%;
          padding-top: 20px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          .pay-img {
            position: relative;
            border-radius: 15px;
            border: none;
            width: 145px;
            height: 145px;

            > div {
              padding: 10px;
              border: 1px solid #e6e6e6;

              img {
                width: 124px;
                height: 124px;
                padding: 0;
                margin: 0;
                border: 0;
                background-color: #ffffff;
              }
            }

            > div:before, > div:after {
              content: '';
              position: absolute;
              width: 10px;
              height: 10px;
            }

            > div:before {
              bottom: 0;
              left: 0;
              border-bottom: 2px solid #36b7e6;
              border-left: 2px solid #36b7e6;
            }

            > div:after {
              bottom: 0;
              right: 0;
              border-bottom: 2px solid #36b7e6;
              border-right: 2px solid #36b7e6;
            }
          }

          .pay-img:before,
          .pay-img:after {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
          }

          .pay-img:before {
            top: 0;
            left: 0;
            border-top: 2px solid #36b7e6;
            border-left: 2px solid #36b7e6;
          }

          .pay-img:after {
            top: 0;
            right: 0;
            border-top: 2px solid #36b7e6;
            border-right: 2px solid #36b7e6;
          }

          .pay-text {
            padding-left: 30px;

            p {
              line-height: 30px;

              span {
                margin: 0 10px 0 5px;
                font-size: 24px;
                font-weight: bold;
                color: #fc5151;
              }

              i {
                font-size: 14px;
                text-decoration: line-through;
              }
            }

            .pay-tip {
              margin-top: 10px;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: flex-start;

              img {
                width: 30px;
                height: 30px;
                margin-right: 10px;
              }

              p {
                span {
                  font-size: 14px;
                  color: #409EFF;
                }
              }
            }
          }
        }
      }
    }
  }

  .share-url {
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .share-title {
      width: 100%;

      h3 {
        text-align: center;
        font-size: 18px;
        color: #3f4654;
        margin-bottom: 13px
      }

      p {
        margin-bottom: 30px;
        text-align: center;
      }
    }

    .url-item {
      width: 100%;
      margin-bottom: 30px;
      display: flex;
      justify-content: center;

      p {
        flex: 1;
        height: 36px;
        background: #fafbfc;
        border-radius: 6px;
        opacity: 1;
        border: 1px solid #e3e5e8;
        box-sizing: border-box;
        padding: 0 16px;
        line-height: 36px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-right: 10px;
        font-size: 12px;
        color: #3f4654;
      }

      .copy {
        width: 110px;
        height: 36px;
        background-image: linear-gradient(90deg, #409EFF, #6e83f7);
        box-shadow: 0 2px 5px rgba(81, 59, 248, 0.3);
        border-radius: 6px;
        opacity: 1;
        line-height: 36px;
        text-align: center;
        font-size: 12px;
        color: #fff;
        cursor: pointer;
      }
    }

    .url-ul {
      width: 100%;
      background-color: #f5f9ff;
      border-radius: 6px;
      border: 1px solid hsla(0, 0%, 43.9%, .08);
      margin: 0 auto;
      padding-bottom: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      > div {
        width: 190px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        border-radius: 0 0 15px 15px;
        background-image: linear-gradient(90deg, #409EFF, #6e83f7);
      }

      p {
        width: 60%;
        margin-top: 20px;
        color: #3f4654;
        font-size: 14px;

        span {
          display: inline-block;
          width: 18px;
          height: 18px;
          line-height: 18px;
          background: #7990c9;
          text-align: center;
          border-radius: 50%;
          margin-right: 10px;
          color: #fff;
          font-size: 14px;
        }
      }
    }

    .url-fot {
      width: 100%;
      padding: 10px 0 20px 0;
      margin-top: 10px;
      text-align: right;
      color: #8b9098;
      font-size: 12px;
    }

    .img-box {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;

      .img-item {
        position: relative;
        width: 200px;
        height: 384px;
        background: #ffffff;
        box-shadow: 0 6px 20px 1px rgba(0, 0, 0, .08);
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        border: 6px solid #ffffff;
        box-sizing: border-box;

        .poster-bg {
          width: 100%;
          height: 100%;
        }

        .ewm-img {
          position: absolute;
          z-index: 2;
          bottom: -15px;
          right: -14px;
          border-radius: 20px;
          overflow: hidden;
          transform: scale(0.435);
        }

        .img-user {
          position: absolute;
          top: 4px;
          left: -34px;
          transform: scale(0.5);
          color: #ffffff;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;

          i {
            width: 30px;
            height: 30px;
            margin-right: 8px;
            font-size: 24px;
            text-align: center;
            line-height: 26px;
            border: 1px solid #ffffff;
            border-radius: 30px;
          }

          .img-user-name {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
          }
        }
      }

      .url-ul {
        width: 200px;
        height: 384px;
        margin: 0;
        justify-content: flex-start;

        p {
          position: relative;
          width: 80%;
          margin-top: 40px;
          padding-left: 35px;

          span {
            margin-left: -28px;
          }
        }
      }
    }

    .url-btn {
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      > div {
        width: 130px;
        height: 36px;
        background-image: linear-gradient(90deg, #409EFF, #6e83f7);
        box-shadow: 0 2px 5px rgba(81, 59, 248, 0.3);
        border-radius: 6px;
        line-height: 36px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          margin-right: 6px;
        }
      }

      > div:last-child {
        margin-left: 40px;
      }
    }
  }

  .showVisible {
    /deep/ .el-dialog {
      border-radius: 15px;
      width: 40% !important;
    }
  }
}
@media screen and (max-width: 900px){
  .main-box {
    width: 100%;
    padding-top: 0;

    .promot-box {
      flex-direction: column;

      .cont-left {
        width: 100%;

        .float-tip {
          left: -5px;
          width: 90px;
        }
      }

      .cont-right {
        width: 100%;
        padding: 20px;

        .r-btn {
          justify-content: space-between;

          > div {
            margin-right: 0;
          }
        }

        .r-btn2 {
          width: 100%;
        }

        .btn-pc-show {
          display: none;
        }

        .btn-h5-show {
          display: flex;
        }
      }
    }

    .share-url {
      width: 100%;

      .url-item {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .copy {
          margin: 10px auto 0 auto;
        }
      }

      .url-ul {
        p {
          width: 80%;
          font-size: 12px;
        }
      }

      .img-box {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .url-ul {
          width: 100%;
          height: auto;
          margin-top: 10px;

          p {
            width: 80%;
            margin-top: 10px;
            font-size: 12px;
          }
        }
      }

      .url-btn {
        width: 100%;
        justify-content: space-between;

        > div {
          width: 55%;
        }

        > div:last-child {
          width: 40%;
          margin-left: 0;
        }
      }
    }

    .showVisible {
      /deep/ .el-dialog {
        margin-top: 5vh !important;
        width: 80% !important;
      }
    }
  }
}
</style>
